import { combineReducers } from "@reduxjs/toolkit";
import medicalCentersSlice from "./medicalCentersSlice";

export default combineReducers({
  medicalCenters: medicalCentersSlice,
});
